<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 text-center class="ibmbold large" pb-14 pb-sm-7>
        <span>Let’s now shop for plants,</span> <br />
        <span> Fruits & spices.</span>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12 md10>
        <v-layout wrap>
          <v-flex md4>
            <v-card flat>
              <v-layout wrap pr-sm-1>
                <v-flex>
                  <v-img
                    contain
                    src="../../assets/Images/Mask Group 1.png"
                    class="white--text bordercurve align-start"
                  >
                    <v-layout wrap pa-8>
                      <v-flex xs12 text-left>
                        <span class="medium ibmbold"
                          >Let’s make the planet Clean</span
                        >
                        <br />
                        <span style="color: #939393" class="smallm ibmbold"
                          >Use Promo Code</span
                        >
                        <br />
                        <span
                          style="
                            border: 1px dashed grey;
                            font-size: 12px;
                            padding: 2px;
                          "
                          >&nbsp;SAVE10
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-img>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex md4 py-2 py-md-0>
            <v-card flat>
              <v-layout wrap px-md-1>
                <v-flex>
                  <v-img
                    contain
                    src="../../assets/Images/Mask Group 2.png"
                    class="white--text bordercurve"
                  >
                    <v-layout wrap pa-8 fill-height>
                      <v-flex xs12 text-left>
                        <span class="medium ibmbold"
                          >Fresh Fruits straight
                        </span>
                        <br />
                        <span class="medium ibmbold">To your Door Step.</span>
                        <br />
                      </v-flex>
                      <v-flex
                        text-left
                        xs12
                        align-self-end
                        class="ibmregular xsmall"
                      >
                        Newly Added
                      </v-flex>
                    </v-layout>
                  </v-img>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex md4>
            <v-card flat>
              <v-layout wrap pl-md-1>
                <v-flex>
                  <v-img
                    contain
                    src="../../assets/Images/Mask Group 3.png"
                    class="white--text bordercurve"
                  >
                    <v-layout wrap pa-8 fill-height>
                      <v-flex xs12 text-left>
                        <span class="medium ibmbold"
                          >Fresh Fruits straight
                        </span>
                        <br />
                        <span class="medium ibmbold">To your Door Step.</span>
                        <br />
                      </v-flex>
                      <v-flex
                        text-left
                        xs6
                        align-self-end
                        class="ibmregular xsmall"
                      >
                        Newly Added
                      </v-flex>
                      <v-flex text-left xs6 align-self-end text-right>
                        <v-icon large light color="#3EA56E"
                          >mdi-arrow-right-circle</v-icon
                        >
                      </v-flex>
                    </v-layout>
                  </v-img>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center pt-2>
      <v-flex xs12 md10>
        <v-card flat>
          <v-img
            height="400px"
            style="border-radius: 5px"
            src="../../assets/Images/bigb.png"
            class="white--text align-center"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)"
          >
            <v-layout wrap fill-height>
              <v-flex xs12 style="font-size: 60px" class="ivyregular sh">
                <span>Enjoy your life </span> <br /><span>with Plants</span>
              </v-flex>
              <v-flex xs12 pt-10 pt-sm-16>
                <v-btn
                to="/Products"
                  width="150px"
                  rounded
                  color="#3EA56E"
                  dark
                  style="text-transform: none"
                  >Shop Now</v-btn
                >
              </v-flex>
            </v-layout>
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    sliderHeight() {
      var height = "300px";
      if (this.$vuetify.breakpoint.xl) height = "450px";
      if (this.$vuetify.breakpoint.lg) height = "300px";
      if (this.$vuetify.breakpoint.md) height = "250px";
      if (this.$vuetify.breakpoint.sm) height = "180px";
      if (this.$vuetify.breakpoint.xs) height = "80px";
      return height;
    },
  },
};
</script>
<style>
@keyframes example {
  from {
    color: #febd08;
  }
  to {
    color: red;
  }
}
.sh {
  text-shadow: 50px 50px 50px #000, 10px 10px 10px black;
}
</style>